import React from 'react';
import { Media } from 'react-breakpoints';
import DesktopHeaderLinks from '../header-links-desktop/header-links-desktop.component';
import MobileHeaderLinks from './../header-links-mobile/header-links-mobile.component';

const HeaderLinks = () => {
    return (
        <div>
            <Media>
                {({ breakpoints, currentBreakpoint }) => {
                    if (
                        currentBreakpoint === 'mobile' ||
                        currentBreakpoint === 'mobileLandscape'
                    ) {
                        return <MobileHeaderLinks />;
                    } else {
                        return <DesktopHeaderLinks />;
                    }
                }}
            </Media>
        </div>
    );
};
export default HeaderLinks;
